import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker, } from '@payit/cool-web-ui-library';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import SearchBar from '../../searchbar/SearchBar';
import DurableQueueService from '../../../service/DurableQueueService';

class FailedQueueItemSearchView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
      startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      endDate: null,
    };

    this.searchBar = React.createRef();
    // value should match the service name prefix of the _SERVICE_PORT constants
    // which are defined in nodejs/modules/Constants.js
    // currently only public services are supported, because of how DurableQueueServiceClient is implemented (see EnvironmentUtils.js)
    // to support private services, we can update how we build baseUrls by adding support for durable queue search to node_services
    this.comboFields = [
      {
        value: '',
        display: 'Choose a Service',
      },
      {
        value: 'CARTING_SERVICE',
        display: 'Carting Service',
      },
      {
        value: 'CITATIONS_SERVICE',
        display: 'Citations Service',
      },
      {
        value: 'DRIVERS_LICENSE_SERVICE',
        display: 'Drivers License Service',
      },
      {
        value: 'NCINTEGRATIONSERVICE',
        display: 'NC Integration Service',
      },
      {
        value: 'PROPERTY_TAX_SERVICE',
        display: 'Property Tax Service',
      },
      {
        value: 'UTILITIES_SERVICE',
        display: 'Utilities Service',
      },
      {
        value: 'VEHICLE_REGISTRATION_SERVICE',
        display: 'Vehicle Registration Service',
      },
      {
        value: 'WATER_SERVICE',
        display: 'Water Service',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  statefulInitialization() {
    const { click, } = this;
    if (click) {
      click();
    }
  }

  onStartDateChange = (dateTime) => {
    this.setState({ startDate: dateTime, });
  };

  onEndDateChange = (dateTime) => {
    this.setState({ endDate: dateTime, });
  };

  reset = () => {
    this.setState({
      searchResults: [],
    });
  };

  onSearch = (event) => {
    this.reset();

    const { startDate, endDate, } = this.state;
    const queueItemContentsClassName = event.search.value;
    const serviceName = event.combo.value;

    if (!queueItemContentsClassName || !startDate || (startDate && endDate && startDate > endDate) || !serviceName) {
      event.kill();
      return;
    }

    const searchRequest = {
      fullyQualifiedQueueItemContentsClassName: event.search.value || null,
      startFailedOnDateInclusive: startDate ? startDate.toISOString() : null,
      endFailedOnDateExclusive: endDate ? endDate.toISOString() : null,
    };
    const request = { searchRequest, serviceName, };

    DurableQueueService.searchFailedQueueItems(request)
      .then((response) => {
        this.setState({
          searchResults: response.data.contents,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  };

  renderResults = () => {
    const { searchResults, } = this.state;
    if (!searchResults) {
      return null;
    }

    const headers = [
      {
        display: 'Failed Queue Item Id',
        value: 'id',
      },
      {
        display: 'Queue Item Created Timestamp',
        value: 'createdAt',
      },
      {
        display: 'Failed Timestamp',
        value: 'failedOn',
      },
      {
        display: 'Failed Reasons',
        value: 'failedReasons',
      },
      {
        display: 'Failed Count',
        value: 'failedCount',
      },
      {
        display: 'Class Name',
        value: 'fullyQualifiedQueueItemContentsClassName',
      },
      {
        display: 'Queue Item Contents',
        value: 'queueItemContents',
      },
      {
        display: 'Queue Item Id',
        value: '_id',
      },
    ];

    const rows = searchResults
      .sort((a, b) => b.failedOn.localeCompare(a.failedOn))
      .map(failedQueueItem => ({
        value: [
          failedQueueItem._id,
          failedQueueItem.queueItem.createdOn,
          failedQueueItem.failedOn,
          failedQueueItem.queueItem.failedReasons,
          failedQueueItem.queueItem.failedCount,
          failedQueueItem.queueItem.fullyQualifiedQueueItemContentsClassName,
          failedQueueItem.queueItem.queueItemContents,
          failedQueueItem.queueItem._id,
        ],
      }));

    return (
      <div style={{ marginTop: '20px', }}>
        <FieldSet title='QueueItem Search Results' style={{ maxHeight: '500px', }}>
          <Grid
            headers={headers}
            rows={rows}
          />
        </FieldSet>
      </div>
    );
  };

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    return (
      <div className='container'>
        <h5>Failed Queue Item Search</h5>
        <br />
        Input required fields Service and Queue Item Contents Class Name
        <SearchBar
          comboFields={this.comboFields}
          defaultText=''
          onClick={this.onSearch}
          clickConsumer={click => this._setClickEvent(click)}
        />
        <hr />
        <div>
          <div className="DatePicker">
            Start Date
            <DateTimePicker
              {...this.props}
              value={this.state.startDate}
              onChange={this.onStartDateChange}
              timeHint="Central time"
            />
          </div>
        </div>
        <hr />
        <div>
          <div className="DatePicker">
            End Date
            <DateTimePicker
              {...this.props}
              value={this.state.endDate}
              onChange={this.onEndDateChange}
              timeHint="Central time"
            />
          </div>
        </div>
        <hr />
        {this.renderResults()}
      </div>
    );
  }
}

FailedQueueItemSearchView.defaultProps = {
  requestedState: undefined,
};

FailedQueueItemSearchView.propTypes = {
  requestedState: PropTypes.string,
};

export default FailedQueueItemSearchView;
